// 店主信息的信息

import { API_BASE_URL, GOODFUSE_IMG_SERVER } from '@utils/constants'
const { WANJIA_BASE } = API_BASE_URL
export const uploadFileApi = `${WANJIA_BASE}/api/common/uploadFile`

export const FORM_STOREMANAGER = [
    {
        type: 'view',
        field: 'headerName',
        title: '店主姓名：',
        value: '--',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'sex',
        title: '性别：',
        value: '--',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'contactTel',
        title: '联系电话：',
        value: '--',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'birthday',
        title: '出生日期：',
        value: '--',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'experience',
        title: '（家电）从业经验：',
        value: '--',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'identityNum',
        title: '身份证号：',
        value: '--',
        col: {
            span: 8
        }
    }
]
// 区域信息

export const FORM_DISTRICTINFO = [
    {
        type: 'view-content',
        field: 'thisYearEstimatedSaleMoney',
        title: '今年预计销售额：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '万元'
        }
    },
    {
        type: 'view-content',
        field: 'regionTownCount',
        title: '区域乡镇数：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '个'
        }
    },
    {
        type: 'view-content',
        field: 'regionStoreCount',
        title: '区域门店数：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '个'
        }
    },
    {
        type: 'view-content',
        field: 'countyStoreCount',
        title: '区县门店数：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '个'
        }
    },
    {
        type: 'view-content',
        field: 'powerTownCount',
        title: '高潜乡镇数：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '个'
        }
    },
    {
        type: 'view-content',
        field: 'powerStoreCount',
        title: '高潜门店数：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '个'
        }
    },
    {
        type: 'view-content',
        field: 'blankPowerStoreCount',
        title: '空白高潜门店数：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '个'
        }
    }
]
// 门店信息
export const FORM_STOREINFO = [
    {
        type: 'view',
        field: 'storeName',
        title: '门店名称：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'storeLevel',
        title: '门店等级：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'storeAccount',
        title: '门店账户：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view-content',
        field: 'area',
        title: '门店面积：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '㎡'
        }
    },
    {
        type: 'view-content',
        field: 'realArea',
        title: '实际使用面积：',
        value: '',
        col: {
            span: 8
        },
        props: {
            suffixText: '㎡'
        }
    },
    {
        type: 'view',
        field: 'storeType',
        title: '门店类型：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'whetherJingdong',
        title: '是否京东帮：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'jingdongStoreName',
        title: '京东帮门店：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'approveSuccessTime',
        title: '正审通过时间：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'upload-img',
        field: 'locationScreenshot',
        title: '门店位置：',
        value: '',
        props: {
            imgView: true,
            imgPrefix: GOODFUSE_IMG_SERVER,
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi
        },
        col: {
            span: 8
        }
    },
    {
        type: 'upload-img',
        field: 'shopFrontPic',
        title: '门头照片：',
        value: '',
        props: {
            imgView: true,
            imgPrefix: GOODFUSE_IMG_SERVER,
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi
        },
        col: {
            span: 8
        }
    },
    // 这个数据后端返回的是一位数组
    {
        type: 'upload-img',
        field: 'outSidePics',
        title: '户外照片：',
        value: '',
        props: {
            imgView: true,
            imgPrefix: GOODFUSE_IMG_SERVER,
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi
        },
        col: {
            span: 8
        }
    },
    {
        type: 'upload-img',
        field: 'storeFullViewPics',
        title: '店内照片：',
        value: [],
        props: {
            imgView: true,
            array: true,
            imgPrefix: GOODFUSE_IMG_SERVER,
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi
        }
    },
    {
        type: 'view',
        field: 'storeAddress',
        title: '门店地址：',
        value: ''
    }
]

// 门店信息
// 经济实力
export const FORM_ECONOMICSTRENGTH = [
    // {
    //     type: 'view',
    //     field: 'registerMoney',
    //     title: '注册资金：',
    //     value: '',
    //     col: {
    //         span: 8,
    //     },
    // },
    // {
    //     type: 'view',
    //     field: 'realMoney',
    //     title: '实缴资金：',
    //     value: '',
    //     col: {
    //         span: 8,
    //     },
    // },
    {
        type: 'view',
        field: 'regionPeopleCount',
        title: '区域人口数量：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'localMarketCapacity',
        title: '当地家电市场容量：',
        value: '',
        col: {
            span: 8
        }
    }
    // {
    //     type: 'view',
    //     field: 'lastYearSaleMoney',
    //     title: '去年销售金额：',
    //     value: '',
    //     col: {
    //         span: 8,
    //     },
    // },
]

///区域信息的表单

export const FORM_DISTRICTINFOFORM = [
    {
        type: 'input-custom',
        field: 'thisYearEstimatedSaleMoney',
        title: '今年预计销售额：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请填写金额',
            suffixText: '万元'
            // type:'number'
        },
        col: {
            span: 8
        },
        validate: [
            { required: true, message: '请填写金额' },
            {
                pattern: /^[0-9]\d*$/,
                message: '应是大于等于0的整数'
            }
        ]
    },
    {
        type: 'input-custom',
        field: 'regionTownCount',
        title: '区域乡镇数：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请填写数量',
            suffixText: '个'
        },
        col: {
            span: 8
        },
        validate: [
            { required: true, message: '请填写数量' },
            {
                pattern: /^[0-9]\d*$/,
                message: '应是大于等于0的整数'
            }
        ]
    },
    {
        type: 'input-custom',
        field: 'regionStoreCount',
        title: '区域门店数：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请填写数量',
            suffixText: '个'
        },
        col: {
            span: 8
        },
        validate: [
            { required: true, message: '请填写数量' },
            {
                pattern: /^[0-9]\d*$/,
                message: '应是大于等于0的整数'
            }
        ]
    },
    {
        type: 'input-custom',
        field: 'countyStoreCount',
        title: '区县门店数：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请填写数量',
            suffixText: '个'
        },
        col: {
            span: 8
        },
        validate: [
            { required: true, message: '请填写数量' },
            {
                pattern: /^[0-9]\d*$/,
                message: '应是大于等于0的整数'
            }
        ]
    },
    {
        type: 'input-custom',
        field: 'powerTownCount',
        title: '高潜乡镇数：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请填写数量',
            suffixText: '个'
        },
        col: {
            span: 8
        },
        validate: [
            { required: true, message: '请填写数量' },
            {
                pattern: /^[0-9]\d*$/,
                message: '应是大于等于0的整数'
            }
        ]
    },
    {
        type: 'input-custom',
        field: 'powerStoreCount',
        title: '高潜门店数：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请填写数量',
            suffixText: '个'
        },
        col: {
            span: 8
        },
        validate: [
            { required: true, message: '请填写数量' },
            {
                pattern: /^[0-9]\d*$/,
                message: '应是大于等于0的整数'
            }
        ]
    },
    {
        type: 'input-custom',
        field: 'blankPowerStoreCount',
        title: '空白高潜门店数：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请填写数量',
            suffixText: '个'
        },
        col: {
            span: 8
        },
        validate: [
            { required: true, message: '请填写空白高潜门店数' },
            {
                pattern: /^[0-9]\d*$/,
                message: '应是大于等于0的整数'
            }
        ]
    }
]

// 网格经理详情页
export const FORM_GRIDMANAGER = [
    {
        type: 'view',
        field: 'jdPin',
        title: '京东账户：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'name',
        title: '申请人姓名：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'tel',
        title: '联系人电话：',
        value: '',
        col: {
            span: 8
        }
    },
    {
        type: 'view',
        field: 'address',
        title: '联系地址：',
        value: ''
        // col: {
        //     span: 8,
        // },
    },
    {
        type: 'view',
        field: 'identityNum',
        title: '身份证号：',
        value: ''
        // col: {
        //     span: 8,
        // },
    },
    {
        type: 'upload-img',
        field: 'idertityPic',
        title: '身份证：',
        value: [],
        props: {
            imgView: true,
            maxSize: 1024 * 5,
            maxNum: 2,
            array: true,
            action: uploadFileApi,
            desc: '支持上传5M以内的.jpg/.png/.jpeg格式图片',
            format: ['jpg', 'png', 'jpeg']
        }
    },
    {
        type: 'upload-file',
        field: 'personalResume',
        title: '个人简历：',
        value: '',
        props: {
            fileView: true,
            buttonName: '上传简历',
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi,
            desc: '支持上传5M以内的.docx/.doc/.pdf格式文件',
            format: ['docx', 'doc', 'pdf']
        }
        // col: {
        //     span: 13,
        // },
    },
    {
        type: 'upload-file',
        field: 'authFile',
        title: '授权书：',
        value: '',
        props: {
            fileView: true,
            buttonName: '上传简历',
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi,
            desc: '支持上传5M以内的.docx/.doc/.pdf格式文件',
            format: ['docx', 'doc', 'pdf']
        }
        // col: {
        //     span: 13,
        // },
    }
]
export const FORM_GRIDMANAGERFORM = [
    {
        type: 'input',
        field: 'jdPin',
        title: '京东账户：',
        value: '',
        col: {
            span: 8
        },
        props: {
            clearable: true,
            placeholder: '请输入京东PIN'
        },
        // domProps: {
        //     style: 'width: 328px;',
        // },
        validate: [{ type: 'string', required: true, message: '请输入京东PIN' }]
    },
    {
        type: 'input',
        field: 'name',
        title: '申请人姓名：',
        value: '',
        col: {
            span: 8
        },
        props: {
            clearable: true,
            placeholder: '请与身份证信息一致'
        },
        // domProps: {
        //     style: 'width: 328px',
        // },
        validate: [
            { type: 'string', required: true, message: '请与身份证信息一致' }
        ]
    },
    {
        type: 'input',
        field: 'tel',
        title: '联系人电话：',
        value: '',
        col: {
            span: 8
        },
        props: {
            clearable: true,
            placeholder: '请输入11位手机号'
        },
        // domProps: {
        //     style: 'width: 328px',
        // },

        validate: [
            { type: 'string', required: true, message: '请输入11位手机号' },
            {
                // /^([1-9]\d*(\.\d*)?)|(0\.\d*[1-9][0-9])|(0\.\d*[1-9])$/
                pattern: /^1\d{10}$/,
                message: '请输入11位手机号'
            }
        ]
    },
    {
        type: 'input',
        field: 'address',
        title: '联系地址：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请输入联系地址，精确到门牌号'
        },
        validate: [
            {
                type: 'string',
                required: true,
                message: '请输入联系地址，精确到门牌号'
            }
        ]
    },
    {
        type: 'input',
        field: 'identityNum',
        title: '身份证号：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请输入身份证号'
        },
        validate: [
            { type: 'string', required: true, message: '请输入身份证号' },
            {
                pattern: /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/,
                message: '请输入正确的身份证号'
            }
        ]
    },
    {
        type: 'upload-img',
        field: 'idertityPic',
        title: '身份证：',
        value: [],
        props: {
            maxSize: 1024 * 5,
            maxNum: 2,
            array: true,
            action: uploadFileApi,
            desc: '支持上传5M以内的.jpg/.png/.jpeg格式图片',
            format: ['jpg', 'png', 'jpeg']
        },
        validate: [
            { required: true, message: '请上传身份证正反页面' },
            {
                type: 'array',
                min: 2,
                required: true,
                message: '请上传身份证正反页面'
            }
        ]
    },
    {
        type: 'upload-file',
        field: 'personalResume',
        title: '个人简历：',
        value: '',
        props: {
            buttonName: '上传简历',
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi,
            desc: '支持上传5M以内的.docx/.doc/.pdf格式文件',
            format: ['docx', 'doc', 'pdf']
        },
        // col: {
        //     span: 13,
        // },
        validate: [{ required: true, message: '请上传个人简历' }]
    },
    {
        type: 'upload-file',
        field: 'authFile',
        title: '授权书：',
        value: '',
        props: {
            buttonName: '上传授权书',
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi,
            desc: '支持上传5M以内的.docx/.doc/.pdf格式文件',
            format: ['docx', 'doc', 'pdf'],
            aHref:
                'https://storage.360buyimg.com/retail-mobile/doc/million/shop/%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6-%E7%BD%91%E6%A0%BC%E7%BB%8F%E7%90%86.docx',
            aName: '授权书模版下载'
        },
        // col: {
        //     span: 13,
        // },
        validate: [{ required: true, message: '请上传授权书' }]
    }
]

// 编辑的时候
export const FORM_GRIDMANAGERFORMMODIFY = [
    {
        type: 'input',
        field: 'jdPin',
        title: '京东账户：',
        value: '',
        col: {
            span: 8
        },
        props: {
            disabled: true,
            clearable: true,
            placeholder: '请输入京东PIN'
        },
        // domProps: {
        //     style: 'width: 328px;',
        // },
        validate: [{ type: 'string', required: true, message: '请输入京东PIN' }]
    },
    {
        type: 'input',
        field: 'name',
        title: '申请人姓名：',
        value: '',
        col: {
            span: 8
        },
        props: {
            disabled: true,
            clearable: true,
            placeholder: '请与身份证信息一致'
        },
        // domProps: {
        //     style: 'width: 328px',
        // },
        validate: [
            { type: 'string', required: true, message: '请与身份证信息一致' }
        ]
    },
    {
        type: 'input',
        field: 'tel',
        title: '联系人电话：',
        value: '',
        col: {
            span: 8
        },
        props: {
            clearable: true,
            placeholder: '请输入11位手机号'
        },
        // domProps: {
        //     style: 'width: 328px',
        // },

        validate: [
            { type: 'string', required: true, message: '请输入11位手机号' },
            {
                // /^([1-9]\d*(\.\d*)?)|(0\.\d*[1-9][0-9])|(0\.\d*[1-9])$/
                pattern: /^1\d{10}$/,
                message: '请输入11位手机号'
            }
        ]
    },
    {
        type: 'input',
        field: 'address',
        title: '联系地址：',
        value: '',
        props: {
            clearable: true,
            placeholder: '请输入联系地址，精确到门牌号'
        },
        validate: [
            {
                type: 'string',
                required: true,
                message: '请输入联系地址，精确到门牌号'
            }
        ]
    },
    {
        type: 'input',
        field: 'identityNum',
        title: '身份证号：',
        value: '',
        props: {
            disabled: true,
            clearable: true,
            placeholder: '请输入身份证号'
        },
        validate: [
            { type: 'string', required: true, message: '请输入身份证号' },
            {
                pattern: /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/,
                message: '请输入正确的身份证号'
            }
        ]
    },
    {
        type: 'upload-img',
        field: 'idertityPic',
        title: '身份证：',
        value: [],
        props: {
            maxSize: 1024 * 5,
            imgView: true,
            maxNum: 2,
            array: true,
            action: uploadFileApi,
            desc: '支持上传5M以内的.jpg/.png/.jpeg格式图片',
            format: ['jpg', 'png', 'jpeg']
        },
        validate: [
            { required: true, message: '请上传身份证正反页面' },
            {
                type: 'array',
                min: 2,
                required: true,
                message: '请上传身份证正反页面'
            }
        ]
    },
    {
        type: 'upload-file',
        field: 'personalResume',
        title: '个人简历：',
        value: '',
        props: {
            fileView: true,
            buttonName: '上传简历',
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi,
            desc: '支持上传5M以内的.docx/.doc/.pdf格式文件',
            format: ['docx', 'doc', 'pdf']
        },
        // col: {
        //     span: 13,
        // },
        validate: [{ required: true, message: '请上传个人简历' }]
    },
    {
        type: 'upload-file',
        field: 'authFile',
        title: '授权书：',
        value: '',
        props: {
            fileView: true,
            buttonName: '上传授权书',
            maxSize: 1024 * 5,
            maxNum: 1,
            action: uploadFileApi,
            desc: '支持上传5M以内的.docx/.doc/.pdf格式文件',
            format: ['docx', 'doc', 'pdf']
        },
        // col: {
        //     span: 13,
        // },
        validate: [{ required: true, message: '请上传授权书' }]
    }
]
